// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1PDqW","colMin":"styles_colMin__3jQEN","colCheckbox":"styles_colCheckbox__3jj9x"};